import { render, staticRenderFns } from "./base-table-layout.vue?vue&type=template&id=44cf8230&scoped=true"
import script from "./base-table-layout.vue?vue&type=script&lang=js"
export * from "./base-table-layout.vue?vue&type=script&lang=js"
import style0 from "./base-table-layout.vue?vue&type=style&index=0&id=44cf8230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cf8230",
  null
  
)

export default component.exports